/* eslint-disable no-prototype-builtins */
import { ConstructionOutlined, ContentCopy, NavigateBefore, NavigateNext } from '@mui/icons-material';
import FullscreenOutlinedIcon from '@mui/icons-material/FullscreenOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import ZoomInOutlinedIcon from '@mui/icons-material/ZoomInOutlined';
import ZoomOutOutlinedIcon from '@mui/icons-material/ZoomOutOutlined';
import { Box, IconButton, Paper, Typography, useTheme } from '@mui/material';
import Annotorious from '@recogito/annotorious-openseadragon';
import '@recogito/annotorious-openseadragon/dist/annotorious.min.css';
import SelectorPack from '@recogito/annotorious-selector-pack';
import OpenSeaDragon from 'openseadragon';
import { TileSource } from 'openseadragon';
import { useContext, useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { AnnotationContext } from '../../context/AnnotationContext';
import { CommonContext } from '../../context/CommonContext';
import { SequencesContext } from '../../context/SequencesContext';
import './Viewer.css';
import HideImageIcon from '@mui/icons-material/HideImage';
import ImageIcon from '@mui/icons-material/Image';
import { AuthContext } from '../../context/AuthContext';
import UndoIcon from '@mui/icons-material/Undo';
import RedoIcon from '@mui/icons-material/Redo';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import CollectionsIcon from '@mui/icons-material/Collections';
import GalleryView from './GalleryView';
import Slider from '@mui/material/Slider';
import AppsIcon from '@mui/icons-material/Apps';
import React from 'react';
const createElementFromHTML = (htmlString: string) => {
  const div = document.createElement('div');
  div.innerHTML = htmlString.trim();

  // Change this to div.childNodes to support multiple top-level nodes.
  return div.children[0];
};

const formatter = (annotation: any) => {
  const tagBodies = annotation.bodies.filter((body: any) => {
    return body.type === 'TextualBody' && body.purpose === 'tagging';
  });

  if (tagBodies.length == 0) return ''; // to work with ground truth annotaiton and the polygon workflow
  return tagBodies[0].value;
};

const Viewer = ({
  annotationType,
  currentAction,
  saveCoordinates,
  currentAnnotationStep,
  annotationExists,
  updateCoordinates,
  deleteCoordinates,
  handleUndoEvent,
  undoAvailable,
  useViews,
}: any) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { id, stageId, sequenceId } = useParams();

  const { isAnnotator } = useContext(AuthContext);
  const {
    getImage,
    getImages,
    getNextImage,
    getPreviousImage,
    image,
    imageIndex,
    images,
    sequence,
    goToNextImage,
    goToPrevImage,
    setMainImage,
    setSpecificImage,
  } = useContext(SequencesContext);
  const { setLoading, setAlertMessage } = useContext(CommonContext);

  //const { currentAction, saveCoordinates, currentAnnotationStep, annotationExists, updateCoordinates } =
  //  useContext(AnnotationContext);
  const [fpsVideoView, setFpsVideoView] = useState<number>(2);
  const [viewer, setViewer] = useState<any>(null);
  const [hideAnno, setHideAnno] = useState<boolean>(true);
  const [mouseOnAnnotation, setMouseOnAnnotation] = useState<boolean>(false);
  const [playView, setPLayView] = useState<any>(false);
  const [galleryView, setGalleryView] = useState<any>(false);
  const [anno, setAnno] = useState<any>(null);
  const [timeoutIds, setTimeoudIds] = useState<any>([]);
  const [clickedAnnotation, setClickedAnnotation] = useState<any>(null);
  const [hiddenAnnotations, setHiddenAnnotations] = useState<any>([]);
  const actionRef = useRef<any>();

  useEffect(() => {
    // /getImages(Number(sequenceId), setAlertMessage);
    if (!anno) return;
    anno.setAnnotations([]);
  }, [sequenceId]);

  useEffect(() => {
    if (!useViews) {
      setGalleryView(false);
      setPLayView(false);
      if (timeoutIds.length > 0) {
        for (const timeoutId of timeoutIds) {
          clearTimeout(timeoutId);
        }
        setTimeoudIds([]);
      }
      //InitOpenseadragon();
      setMainImage();
    }
  }, [useViews]);

  useEffect(() => {
    if (playView) {
      goToNextImage();
    } else {
      for (const timeoutId of timeoutIds) {
        clearTimeout(timeoutId);
      }
      setTimeoudIds([]);
    }
  }, [playView]);

  useEffect(() => {
    if (!image) return;

    changeImage(image);
  }, [image]);

  useEffect(() => {
    if (!currentAnnotationStep || !anno) return;
    const tempAnnotations = [];
    if (currentAnnotationStep.mainImage) {
      goToMainImage();
      if (annotationType === 'ground_truth_annotation') {
        for (const template of currentAnnotationStep.template) {
          for (const annotationId in template.annotoriousFormats) {
            const annotoriousFormat = template.annotoriousFormats[annotationId];
            if (!hiddenAnnotations.includes(annotoriousFormat.id)) tempAnnotations.push(annotoriousFormat);
          }
        }
      } else {
        for (const label of currentAnnotationStep.template) {
          if (label.annotoriousFormat) tempAnnotations.push(label.annotoriousFormat);
        }
      }
    }
    anno.setAnnotations(tempAnnotations);
    //setClickedAnnotation(null);
  }, [currentAnnotationStep]);

  useEffect(() => {
    if (!anno) return;
    if (annotationExists) anno.disableSelect = true;
    else anno.disableSelect = false;
  }, [annotationExists, anno]);

  useEffect(() => {
    if (!isAnnotator()) return;
    if (!currentAnnotationStep || !anno) return;
    const tempAnnotations = [];
    const newHiddenAnnotations = [...hiddenAnnotations];
    for (const template of currentAnnotationStep.template) {
      for (const annotationId in template.annotoriousFormats) {
        const annotoriousFormat = template.annotoriousFormats[annotationId];
        if (!newHiddenAnnotations.includes(annotoriousFormat.id)) tempAnnotations.push(annotoriousFormat);
      }
    }
    anno.setAnnotations(tempAnnotations);
  }, [hiddenAnnotations]);

  useEffect(() => {
    if (!viewer || !anno) return;
    anno.setDrawingEnabled(false);
    actionRef.current = currentAction;

    if (!currentAction) return;
    if (currentAction.type === 'annotation') {
      anno.setDrawingEnabled(true);
      anno.setDrawingTool(currentAction.tool);
      //anno.setDrawingTool('point');
    }
  }, [currentAction]);

  const InitOpenseadragon = () => {
    viewer && viewer.destroy();

    const _viewer: any = OpenSeaDragon({
      id: 'openSeaDragon',
      prefixUrl: 'http://openseadragon.github.io/openseadragon/images/',
      showNavigationControl: true,
      zoomInButton: 'zoom-in',
      zoomOutButton: 'zoom-out',
      homeButton: 'home',
      fullPageButton: 'full-page',
      //sequenceMode: true,
      //tileSources: [
      //  {
      //    type: 'image',
      //    url: image.s3_info.presigned_url,
      //  },
      //],
      gestureSettingsMouse: {
        clickToZoom: false,
      },
    });

    _viewer.innerTracker.keyHandler = null;
    _viewer.innerTracker.keyPressHandler = null;

    _viewer.addHandler('open', () => {
      if (!playView) {
        setLoading(false);
      }
    });

    initAnnotorious(_viewer);

    setViewer(_viewer);
  };
  const initAnnotorious = (viewer: any) => {
    anno && anno.destroy();

    const config = {
      disableEditor: true,
      formatter: formatter,
    };
    const annotate = Annotorious(viewer, config);
    SelectorPack(annotate);
    annotate.setDrawingEnabled(false);

    annotate.setAnnotations([]);

    annotate.on('createSelection', async (selection: any) => {
      selection.body = [
        {
          type: 'TextualBody',
          purpose: 'tagging',
          value: actionRef.current.id,
          color: actionRef.current.color,
        },
      ];
      annotate.updateSelected(selection, true);
    });

    annotate.on('createAnnotation', (annotation: any) => {
      if (annotationType === 'ground_truth_annotation') {
        const svgPolygon = createElementFromHTML(annotation.target.selector.value);
        let pointCoordinates: any = svgPolygon.getElementsByTagName('polygon')[0].getAttribute('points');
        pointCoordinates = pointCoordinates.split(' ');
        pointCoordinates = pointCoordinates.map((point: string) => {
          return {
            x: parseInt(point.split(',')[0]),
            y: parseInt(point.split(',')[1]),
          };
        });

        saveCoordinates(pointCoordinates, annotation);
      } else {
        const annotoriousCoordinatesValue = annotation.target.selector.value.split(':');
        const bBoxString = annotoriousCoordinatesValue[1];
        const pointCoordinates = bBoxString.split(',').map(Number).slice(0, 2);
        saveCoordinates(pointCoordinates, annotation);
      }
    });
    const handleUpdatePolygon = (annotation: any) => {
      const svgPolygon = createElementFromHTML(annotation.target.selector.value);
      let pointCoordinates: any = svgPolygon.getElementsByTagName('polygon')[0].getAttribute('points');
      pointCoordinates = pointCoordinates.split(' ');
      pointCoordinates = pointCoordinates.map((point: string) => {
        return {
          x: parseInt(point.split(',')[0]),
          y: parseInt(point.split(',')[1]),
        };
      });
      updateCoordinates(annotation.id, pointCoordinates, annotation);
    };
    annotate.on('updateAnnotation', (annotation: any, previous: any) => {
      if (annotationType === 'user_annotation') {
        const annotoriousCoordinatesValue = annotation.target.selector.value.split(':');
        const bBoxString = annotoriousCoordinatesValue[1];
        const pointCoordinates = bBoxString.split(',').map(Number).slice(0, 2);
        updateCoordinates(pointCoordinates, annotation);
      } else {
        //annotate.cancelSelected();
        //setClickedAnnotation(null);
        handleUpdatePolygon(annotation);
      }
    });

    if (isAnnotator()) {
      annotate.on('selectAnnotation', (annotation: any) => {
        setClickedAnnotation(annotation);
      });

      annotate.on('cancelSelected', function (annotation: any) {
        if (clickedAnnotation) handleUpdatePolygon(clickedAnnotation);
        setClickedAnnotation(null);
      });
    }
    setAnno(annotate);
  };

  useEffect(() => {
    if (galleryView) {
      viewer.close();
    } else {
      if (!(viewer == null)) {
        if (!viewer.isOpen()) {
          InitOpenseadragon();
          //viewer.open();
          //changeImage(image);
          //viewer?.open({
          //  type: 'image',
          //  url: image.s3_info.presigned_url,
          //});
          //viewer?.setVisible();
        }
      }
    }
  }, [galleryView]);

  useEffect(() => {
    if (viewer || anno) return;
    InitOpenseadragon();
    return () => {
      viewer && viewer.destroy();
      anno && anno.destroy();
    };
  }, []);

  useEffect(() => {
    if (!viewer || !image) return;
    if (playView) {
      setTimeoudIds([...timeoutIds, setTimeout(goToNextImage, 1000 / fpsVideoView)]);
    }
    changeImage(image);
  }, [viewer, image]);

  const changeImage = async (file: any) => {
    if (!playView) {
      setLoading(true);
    }
    //const img = new Image();
    //img.src = file.s3_info.presigned_url;
    //await img.decode();
    //const ts = new TileSource({
    //  url: file.s3_info.presigned_url,
    //});
    //ts.downloadTileStart();
    viewer?.open({
      type: 'image',
      url: file.s3_info.presigned_url,
      //url: img,
    });
  };

  const goToMainImage = () => {
    //const mainImageId = sequence.main_image_id;
    //navigate(`/projects/${id}/stages/${stageId}/sequences/${sequenceId}/images/${mainImageId}`);
    setGalleryView(false);
    setPLayView(false);
    setMainImage();
  };

  const nextFile = () => {
    if (currentAnnotationStep.mainImage) return;
    goToNextImage();
    //const nextImage = getNextImage();
    //navigate(`/projects/${id}/stages/${stageId}/sequences/${sequenceId}/images/${nextImage}`);
  };

  const prevFile = () => {
    if (currentAnnotationStep.mainImage) return;
    goToPrevImage();
    //const previousImage = getPreviousImage();
    //navigate(`/projects/${id}/stages/${stageId}/sequences/${sequenceId}/images/${previousImage}`);
  };

  const onDialogKeyPress = (e: { key: string }) => {
    if (e.key === 'ArrowRight') {
      nextFile();
    }
    if (e.key === 'ArrowLeft') {
      prevFile();
    }
  };

  const handleDeleteClick = () => {
    if (!clickedAnnotation) return;
    //anno.selectAnnotation(clickedAnnotation.id);
    setClickedAnnotation(null);
    deleteCoordinates(clickedAnnotation.id);
  };

  const handleHideClick = () => {
    if (!clickedAnnotation) {
      if (hideAnno) {
        anno.setVisible(false);
        setHideAnno(false);
      } else {
        anno.setVisible(true);
        setHideAnno(true);
      }
    } else {
      const tempAnnotations = [];
      const newHiddenAnnotations = [...hiddenAnnotations];
      for (const template of currentAnnotationStep.template) {
        for (const annotationId in template.annotoriousFormats) {
          const annotoriousFormat = template.annotoriousFormats[annotationId];
          if (annotoriousFormat.id === clickedAnnotation.id) {
            newHiddenAnnotations.push(annotoriousFormat.id);
          } else if (newHiddenAnnotations.includes(annotoriousFormat.id)) {
            continue;
          } else {
            tempAnnotations.push(annotoriousFormat);
          }
        }
      }
      setClickedAnnotation(null);
      setHiddenAnnotations(newHiddenAnnotations);
    }
  };

  const handleUnHideClick = () => {
    setHiddenAnnotations([]);
    setClickedAnnotation(null);
    setHideAnno(true);
    anno.setVisible(true);
  };

  const handleUndoClick = () => {
    if (undoAvailable) {
      handleUndoEvent();
    }
  };

  const handlePlayClick = () => {
    setPLayView(!playView);
  };

  const handleGalleryClick = () => {
    setGalleryView(!galleryView);
  };

  const handleImageClickGalleryView = (image: any) => {
    setSpecificImage(image);
    setGalleryView(false);
  };
  // Define the props type
  interface IframeProps {
    src: string;
    height: string | number;
    width: string | number;
  }

  //const Iframe: React.FC<IframeProps> = ({ src, height, width }) => {
  //  return (
  //    <div>
  //      <iframe src={src} height={height} width={width} />
  //    </div>
  //  );
  //};

  //return(<Iframe src="http://localhost:3030/segmentation?StudyInstanceUIDs=1.3.12.2.1107.5.2.32.35162.30000015050317233592200000046" height="500" width="500"/>);
  return (
    <Box
      onKeyDown={onDialogKeyPress}
      onMouseLeave={() => {
        anno.saveSelected();
        anno.cancelSelected();
        if (clickedAnnotation) {
          setClickedAnnotation(null);
        }
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-start',
          flexDirection: 'row',
          alignItems: 'center',
          zIndex: 5,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexGrow: 1,
            alignItems: 'center',
          }}
        >
          {isAnnotator() ? (
            <IconButton
              onClick={() => {
                handleHideClick();
              }}
              aria-label='hide-annotation'
              id='hide-annotation'
              size='small'
              disabled={!currentAnnotationStep?.mainImage}
              color={clickedAnnotation ? 'secondary' : 'primary'}
            >
              <HideImageIcon />
            </IconButton>
          ) : null}
          {isAnnotator() ? (
            <IconButton
              onClick={() => {
                handleUnHideClick();
              }}
              aria-label='unhide-annotation'
              id='unhide-annotation'
              size='small'
              disabled={!(hiddenAnnotations.length > 0)}
              color={'secondary'}
            >
              <ImageIcon />
            </IconButton>
          ) : null}
          {isAnnotator() ? (
            <IconButton
              onClick={() => {
                handleDeleteClick();
              }}
              aria-label='delete-annotation'
              id='delete-annotation'
              size='small'
              disabled={!(clickedAnnotation !== null)}
              color={'secondary'}
            >
              <DeleteIcon />
            </IconButton>
          ) : null}

          {isAnnotator() ? (
            <IconButton
              onClick={() => {
                handleUndoClick();
              }}
              aria-label='undo-annotation'
              id='undo-annotation'
              size='small'
              disabled={!undoAvailable}
              color={'secondary'}
            >
              <UndoIcon />
            </IconButton>
          ) : null}
        </Box>
      </Box>
      <Paper
        sx={{
          height: '85vh',
          // boxShadow: '-0px -0px 2px 4px rgba(255,144,0,0.22)',
          // border: '1px solid',
          zIndex: 4,
        }}
        elevation={3}
      >
        {galleryView ? <GalleryView handleImageClickGalleryView={handleImageClickGalleryView} /> : null}
        <Box
          id='openSeaDragon'
          sx={
            currentAction
              ? {
                  height: '81vh',
                  border: '0px solid',
                  cursor: 'crosshair',
                }
              : {
                  height: '81vh',
                  border: '0px solid',
                  cursor: 'grab',
                }
          }
          style={galleryView ? { display: 'none' } : { display: 'none' }}
        />
        {sequence ? <iframe src={sequence.info} width='100%' height='100%' /> : null}
      </Paper>
    </Box>
  );
};

export default Viewer;
